require('dotenv').config()

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/plugins/base'

import vuetify from '@/plugins/vuetify'
// import i18n from './i18n'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import Loading from '@/components/Loading.vue'
import moment from 'moment'
import VueUUID from 'vue-uuid'

import VueAudio from 'vue-audio-better'
Vue.use(VueAudio)

import '@/sass/overrides.sass'

Vue.config.productionTip = false

import "@/plugins/mixin";
import "@/plugins/filters";

Vue.use(VueLodash, {lodash: lodash})
Vue.use(VueUUID);

Vue.component('loadingData', Loading)

Vue.prototype.moment = moment

import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker)

// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

// Sentry.init({
//     Vue,
//     dsn: "https://ea783783d23749da8f64e66d1d6afbdc@o553956.ingest.sentry.io/5681879",
//     integrations: [new Integrations.BrowserTracing()],
//
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 0.8,
//     environment: process.env.VUE_APP_ENVIRONMENT,
// });

import ServiceCard from '@/view/dashboard/pages/service/ServiceCard'
Vue.component("ServiceCard", ServiceCard)

new Vue({
    router,
    store,
    vuetify,
    // i18n,
    render: h => h(App),
    created() {
        window.addEventListener('beforeunload', this.updateHandler)
    },
    beforeDestroy() {
        this.finalDestroyHub()
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.updateHandler)
    },
    methods: {
        updateHandler() {
            this.finalDestroyHub()
        },
        finalDestroyHub() {
            this.$store.dispatch('destroyHub')
        },
        playSound (sound) {
            if(sound) {
                const audio = new Audio(sound);
                audio.play();
            }
        }
    }
}).$mount('#app')

window.Vue = Vue

window.VueEvent = new class {
    constructor(){
        this.vue = new Vue()
    }
    fire(event, data = null){
        this.vue.$emit(event, data)
    }
    listen(event, callback){
        this.vue.$on(event, callback)
    }
};